document.addEventListener("DOMContentLoaded", () => {
    // accordion block toggle
    const accordions = document.querySelectorAll(".accordion-block");
    accordions.forEach(accordion => {
        const container = accordion.parentNode;
        const heading = accordion.querySelector(".accordion-heading");

        heading.addEventListener("click", () => {
            accordions.forEach(otherAccordion => {
                if (accordion == otherAccordion || otherAccordion.parentNode !== container) return;
                otherAccordion.classList.remove("accordion-block-active");
            });
            accordion.classList.toggle("accordion-block-active");
        });
    });
});